import DEFINE, { PATHS } from './../constants/Define';

export default [{
    title: "hotels",
    tagSub: "hotels",
    exact: false,
    path: PATHS.HOTEL.path,
    show: true,
    icon: "faHotel",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.HOTEL_MANAGEMENT,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "hotels",
            group: "hotels",
            tagSub: "hotels",
            path: PATHS.HOTEL.LIST.path,
            exact: false,
            icon: 'faBed',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.HOTEL,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createHotels",
                    group: "hotels",
                    tagSub: "hotels",
                    path: PATHS.HOTEL.CREATE.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                }, {
                    title: "updateHotels",
                    group: "hotels",
                    tagSub: "hotels",
                    path: PATHS.HOTEL.DETAIL.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                }
            ]
        },{
            title: "homestays",
            group: "homestays",
            tagSub: "hotels",
            path: PATHS.HOMESTAY.LIST.path,
            exact: false,
            icon: 'faSuitcase',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.HOMESTAY,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createHomestays",
                    group: "homestays",
                    tagSub: "hotels",
                    path: PATHS.HOMESTAY.CREATE.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                }, {
                    title: "updateHomestays",
                    group: "homestays",
                    tagSub: "hotels",
                    path: PATHS.HOMESTAY.DETAIL.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                    children: [
                        {
                            title: "homestayRoomTypes",
                            group: "updateHomestays",
                            tagSub: "hotels",
                            path: PATHS.HOMESTAY_ROOM_TYPE.LIST.path,
                            exact: false,
                            icon: "home",
                            show: false,
                            routeName: DEFINE.GENERAL.ROUTE_NAME.HOMESTAY_ROOM_TYPE,
                            permissions: [
                                DEFINE.GENERAL.PERMISSION.VIEW,
                                DEFINE.GENERAL.PERMISSION.CREATE,
                                DEFINE.GENERAL.PERMISSION.UPDATE,
                                DEFINE.GENERAL.PERMISSION.DELETE
                            ],
                            children: [
                                {
                                    title: "createHomestayRoomTypes",
                                    group: "homestayRoomTypes",
                                    tagSub: "hotels",
                                    path: PATHS.HOMESTAY_ROOM_TYPE.CREATE.path,
                                    exact: false,
                                    icon: "home",
                                    show: false
                                },
                                {
                                    title: "updateHomestayRoomTypes",
                                    group: "homestayRoomTypes",
                                    tagSub: "hotels",
                                    path: PATHS.HOMESTAY_ROOM_TYPE.DETAIL.path,
                                    exact: false,
                                    icon: "home",
                                    show: false
                                }
                            ]
                        },{
                            title: "homestayRates",
                            group: "updateHomestays",
                            tagSub: "hotels",
                            path: PATHS.HOMESTAY_RATE.LIST.path,
                            exact: false,
                            icon: "home",
                            show: false,
                            routeName: DEFINE.GENERAL.ROUTE_NAME.HOMESTAY_RATEPLAN,
                            permissions: [
                                DEFINE.GENERAL.PERMISSION.VIEW,
                                // DEFINE.GENERAL.PERMISSION.CREATE,
                                DEFINE.GENERAL.PERMISSION.UPDATE,
                                DEFINE.GENERAL.PERMISSION.SYNC
                            ],
                            children: [
                                {
                                    title: "createHomestayRates",
                                    group: "homestays",
                                    tagSub: "hotels",
                                    path: PATHS.HOMESTAY_RATE.CREATE.path,
                                    exact: false,
                                    icon: "home",
                                    show: false
                                },
                                {
                                    title: "updateHomestayRates",
                                    group: "homestays",
                                    tagSub: "hotels",
                                    path: PATHS.HOMESTAY_RATE.DETAIL.path,
                                    exact: false,
                                    icon: "home",
                                    show: false
                                }
                            ]
                        }
                    ]
                }
            ]
        },{
            title: "locations",
            group: "locations",
            tagSub: "hotels",
            path: PATHS.LOCATION.LIST.path,
            exact: false,
            icon: 'environment',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.LOCATION,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createLocations",
                    group: "locations",
                    tagSub: "hotels",
                    path: PATHS.LOCATION.CREATE.path,
                    exact: false,
                    icon: 'environment',
                    show: false,
                }, {
                    title: "updateLocations",
                    group: "locations",
                    tagSub: "hotels",
                    path: PATHS.LOCATION.DETAIL.path,
                    exact: false,
                    icon: 'environment',
                    show: false,
                }
            ]
        }, {
            title: "popularPlaces",
            group: "popularPlaces",
            tagSub: "hotels",
            path: PATHS.POPULAR_PLACE.LIST.path,
            exact: false,
            icon: 'compass',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.POPULAR_PLACE,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createPopularPlaces",
                    group: "popularPlaces",
                    tagSub: "hotels",
                    path: PATHS.POPULAR_PLACE.CREATE.path,
                    exact: false,
                    icon: 'compass',
                    show: false,
                }, {
                    title: "updatePopularPlaces",
                    group: "popularPlaces",
                    tagSub: "hotels",
                    path: PATHS.POPULAR_PLACE.DETAIL.path,
                    exact: false,
                    icon: 'compass',
                    show: false,
                }
            ]
        }, {
            title: "customPrices",
            group: "customPrices",
            tagSub: "hotels",
            path: PATHS.CUSTOM_PRICE.LIST.path,
            exact: false,
            icon: 'dollar',
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.CUSTOM_PRICE,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createCustomPrices",
                    group: "customPrices",
                    tagSub: "hotels",
                    path: PATHS.CUSTOM_PRICE.CREATE.path,
                    exact: false,
                    icon: 'dollar',
                    show: false,
                }, {
                    title: "updateCustomPrices",
                    group: "customPrices",
                    tagSub: "hotels",
                    path: PATHS.CUSTOM_PRICE.DETAIL.path,
                    exact: false,
                    icon: 'dollar',
                    show: false,
                }
            ]
        }, {
            title: "roomTypes",
            group: "roomTypes",
            tagSub: "hotels",
            path: PATHS.ROOM_TYPE.LIST.path,
            exact: false,
            icon: "home",
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.ROOM_TYPE,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.CREATE,
                DEFINE.GENERAL.PERMISSION.UPDATE,
                DEFINE.GENERAL.PERMISSION.DELETE
            ],
            children: [
                {
                    title: "createRoomTypes",
                    group: "roomTypes",
                    tagSub: "hotels",
                    path: PATHS.ROOM_TYPE.CREATE.path,
                    exact: false,
                    icon: "home",
                    show: false
                },
                {
                    title: "updateRoomTypes",
                    group: "roomTypes",
                    tagSub: "hotels",
                    path: PATHS.ROOM_TYPE.DETAIL.path,
                    exact: false,
                    icon: "home",
                    show: false
                }
            ]
        }, {
            title: "rates",
            group: "rates",
            tagSub: "hotels",
            path: PATHS.RATE.LIST.path,
            exact: false,
            icon: "home",
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.RATEPLAN,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                // DEFINE.GENERAL.PERMISSION.CREATE,
                DEFINE.GENERAL.PERMISSION.UPDATE,
                DEFINE.GENERAL.PERMISSION.SYNC
            ],
            children: [
                {
                    title: "createRates",
                    group: "hotels",
                    tagSub: "hotels",
                    path: PATHS.RATE.CREATE.path,
                    exact: false,
                    icon: "home",
                    show: false
                },
                {
                    title: "updateRates",
                    group: "hotels",
                    tagSub: "hotels",
                    path: PATHS.RATE.DETAIL.path,
                    exact: false,
                    icon: "home",
                    show: false
                }
            ]
        }, {
            title: "bookablePackageRates",
            group: "bookablePackageRates",
            tagSub: "hotels",
            path: PATHS.BOOKABLE_PACKAGE_RATE.LIST.path,
            exact: false,
            icon: "home",
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.BOOKABLEPACKAGERATES,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                // DEFINE.GENERAL.PERMISSION.CREATE,
                DEFINE.GENERAL.PERMISSION.UPDATE,
                DEFINE.GENERAL.PERMISSION.SYNC
            ],
            children: [
                {
                    title: "createBookablePackageRates",
                    group: "hotels",
                    tagSub: "hotels",
                    path: PATHS.BOOKABLE_PACKAGE_RATE.CREATE.path,
                    exact: false,
                    icon: "home",
                    show: false
                },
                {
                    title: "updateBookablePackageRates",
                    group: "hotels",
                    tagSub: "hotels",
                    path: PATHS.BOOKABLE_PACKAGE_RATE.DETAIL.path,
                    exact: false,
                    icon: "home",
                    show: false
                }
            ]
        }, {
            title: "amenities",
            group: "amenities",
            tagSub: "hotels",
            path: PATHS.AMENITY.LIST.path,
            exact: true,
            icon: 'faTasks',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.HOTEL,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createAmenity",
                    group: "amenities",
                    tagSub: "hotels",
                    path: PATHS.AMENITY.CREATE.path,
                    exact: false,
                    icon: 'environment',
                    show: false,
                }, {
                    title: "updateAmenity",
                    group: "amenities",
                    tagSub: "hotels",
                    path: PATHS.AMENITY.DETAIL.path,
                    exact: false,
                    icon: 'environment',
                    show: false,
                }
            ]
        },
        {
            title: "configPHS",
            group: "configPHS",
            tagSub: "hotels",
            path: PATHS.CONFIG_PHS.DETAIL.path,
            exact: false,
            icon: 'tool',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.CONFIG_PHS,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.UPDATE,
            ],
            children: [
                {
                    title: "createRedirectLink",
                    group: "redirectlink",
                    tagSub: "hotels",
                    path: PATHS.REDIRECT_LINK.CREATE.path,
                    exact: false,
                    icon: 'link',
                    show: false,
                }, {
                    title: "updateRedirectLink",
                    group: "redirectlink",
                    tagSub: "hotels",
                    path: PATHS.REDIRECT_LINK.DETAIL.path,
                    exact: false,
                    icon: 'link',
                    show: false,
                }
            ]
        },
        {
            title: "payAtHotel",
            group: "payAtHotel",
            tagSub: "hotels",
            path: PATHS.PAY_AT_HOTEL.path,
            exact: false,
            icon: 'control',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.PAY_AT_HOTEL,
            permissions: [DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.VIEW],
        }, 
        {
            title: "markupBundles",
            group: "markupBundles",
            tagSub: "hotels",
            path: PATHS.MARKUP_BUNDLE.LIST.path,
            exact: false,
            icon: 'faCalendarPlus',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.MARKUP_BUNDLE,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createMarkupBundle",
                    group: "markupBundles",
                    tagSub: "hotels",
                    path: PATHS.MARKUP_BUNDLE.CREATE.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                }, {
                    title: "updateMarkupBundle",
                    group: "markupBundles",
                    tagSub: "hotels",
                    path: PATHS.MARKUP_BUNDLE.DETAIL.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                }
            ]
        },
        {
            title: "packageRate",
            group: "packageRate",
            tagSub: "hotels",
            path: PATHS.PACKAGE_RATE.LIST.path,
            exact: false,
            icon: 'dollar',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.PACKAGERATES,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createPackageRate",
                    group: "packageRate",
                    tagSub: "hotels",
                    path: PATHS.PACKAGE_RATE.CREATE.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                }, {
                    title: "updatePackageRate",
                    group: "packageRate",
                    tagSub: "hotels",
                    path: PATHS.PACKAGE_RATE.DETAIL.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                }, {
                    title: "viewPackageRate",
                    group: "packageRate",
                    tagSub: "hotels",
                    path: PATHS.PACKAGE_RATE.VIEW.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                }
            ]
        }, {
            title: "rateCompare",
            group: "rateCompare",
            tagSub: "hotels",
            path: PATHS.RATE_COMPATE.LIST.path,
            exact: false,
            icon: "home",
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.RATE_COMPARE,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
            ],
            children: [
                {
                    title: "createRateCompare",
                    group: "hotels",
                    tagSub: "hotels",
                    path: PATHS.RATE_COMPATE.CREATE.path,
                    exact: false,
                    icon: "home",
                    show: false
                },
                {
                    title: "updateRateCompare",
                    group: "hotels",
                    tagSub: "hotels",
                    path: PATHS.RATE_COMPATE.DETAIL.path,
                    exact: false,
                    icon: "home",
                    show: false
                }
            ]
        },
    ],
},]